import { createReducer } from 'redux-act';
import * as actions from '#app/actions/transferTradesApi';

interface TransferTradesApiState {
  modalVisible: boolean;
  form: Record<string, unknown>;
  notificationIds: unknown[];
}

const initialState: TransferTradesApiState = {
  modalVisible: false,
  form: {},
  notificationIds: [],
};

const setTransferTradesApiModalVisible = (
  state: TransferTradesApiState,
  bool: boolean
): TransferTradesApiState => ({
  ...state,
  modalVisible: bool,
});

const setTransferTradesApiForm = (
  state: TransferTradesApiState,
  form: Record<string, unknown>
): TransferTradesApiState => ({
  ...state,
  form: form,
  modalVisible: true,
});

const closeTransferTradesApiForm = (state: TransferTradesApiState): TransferTradesApiState => ({
  ...state,
  form: {},
  modalVisible: false,
  notificationIds: [],
});

const setTransferTradesApiNotificationIds = (
  state: TransferTradesApiState,
  ids: unknown[]
): TransferTradesApiState => ({
  ...state,
  notificationIds: ids,
});

export default createReducer<TransferTradesApiState>(
  {
    [actions.setTransferTradesApiModalVisible as any]: setTransferTradesApiModalVisible,
    [actions.setTransferTradesApiForm as any]: setTransferTradesApiForm,
    [actions.closeTransferTradesApiForm as any]: closeTransferTradesApiForm,
    [actions.setTransferTradesApiNotificationIds as any]: setTransferTradesApiNotificationIds,
  },
  initialState
);
